
import { forwardRef, useState } from "react";
import { AvatarProps } from "@mui/material";

import AvatarRoot from "./AvatarRoot";
import Helpers from "../../commons/helpers";

interface Props extends AvatarProps {
    text?: string;
    size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
    shadow?: "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "inset";
    bgColor?: | "info" | "primary" | "transparent" | "secondary" | "success" | "warning" | "error" | "light" | "dark";
    // [key: string]: any;
}

const Avatar = forwardRef<HTMLDivElement, Props>(({ text, bgColor, size, shadow, ...rest }, ref) => {

    const [isError, setIsError] = useState(false);
    const newText = Helpers.getCharacterAvatar(text || "");

    const stringToColor = (): any => {
        let hash = 0;

        for (let i = 0; i < (text || "").length; i++) {
            hash = (text || "").charCodeAt(i) + ((hash << 5) - hash)
        };

        let color = "";

        for (let i = 0; i < 3; i++) {
            const value = ((hash >> (i * 8)) & 0xff);
            color += value.toString(16);
        };

        if (color.length < 6) {
            const str = Array.from({ length: (6 - color.length) }).fill(0).join("");
            color = `${str}${color}`;
        }

        return `#${color.substring(0, 6)}`;
    };

    return (
        <AvatarRoot
            ref={ref}
            ownerState={{ shadow, bgColor, size }}
            {...rest}

            onError={() => { setIsError(true); }}
            src={(Helpers.isNullOrEmpty(rest.src) || isError) ? null : rest.src}
            style={{
                ...rest.style,
                backgroundColor: (Helpers.isNullOrEmpty(rest.src) || isError) ? stringToColor() : "transparent",
            }}
        >
            {
                (Helpers.isNullOrEmpty(rest.src) || isError) ? newText : undefined
            }
        </AvatarRoot>
    );
});

Avatar.defaultProps = {
    size: "md",
    shadow: "none",
    bgColor: "transparent",
};

export default Avatar;
